import React from 'react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { DollarSign, ArrowRight } from 'lucide-react'; // Placeholder icon, Added ArrowRight

const ApiPlatformMonetization: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 md:px-8 lg:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <motion.h1 
              className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-blue-500"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              API & Platform Monetization
            </motion.h1>
            <motion.p 
              className="text-xl md:text-2xl font-medium mb-8 text-foreground/80"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Micropayments Architecture Services designed to grow your business, expand your reach, and reduce friction.
            </motion.p>
            {/* Updated Contact CTA Button styling */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <a
                href="/Contact"
                aria-label="Contact us to get started"
                // Applying classes for Button size="lg" variant="outline"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-11 px-8 gap-2"
                role="button"
              >
                Contact Us
                <ArrowRight className="w-4 h-4" /> {/* Consistent icon size */}
              </a>
            </motion.div>
            {/* Add more content/sections later */}
          </div>
          <motion.div 
            className="lg:w-1/2 flex items-center justify-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <DollarSign className="h-48 w-48 text-primary/50" />
          </motion.div>
        </div>
      </section>

      {/* Placeholder for additional content */}
      <section className="py-20">
        <div className="px-4 sm:px-6 md:px-8 lg:px-10 max-w-7xl mx-auto">
          <p className="text-center text-muted-foreground">More details about API & Platform Monetization solutions coming soon...</p>
        </div>
      </section>
    </div>
  );
};

export default ApiPlatformMonetization; 